module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/7d7e616c9bac2ac2f8c45521918e769e.png";